import React from "react";
import PropTypes from "prop-types";


const PrintDocumentSignature = (props) => {
  const {styles, isContractSign, receiptSignature, userInfo, assignQuotePopupCustomer, locale, fabricatorData, messages} = props;
  const {receiptSettings} = fabricatorData;

  const {View, Text, Image} = window.ReactPdfRenderer;

  const customerName = assignQuotePopupCustomer
    ? assignQuotePopupCustomer.fullName
    : userInfo.firstName + (userInfo.lastName ? (" " + userInfo.lastName) : "");

  const formattedDate = (new Date().toLocaleString(locale,
    {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'}
  )).replace(/,/g, "");

  return (
    <View style={styles.signature} wrap={false}>
      <View style={[styles.section, styles.sectionLeft]}>
        <Text style={[styles.signatureValue, styles.black]}>
          {receiptSettings && receiptSettings.doNotFillNameAndDate ? null : customerName}
        </Text>
        <Text style={styles.signatureText}>{messages["receipt.signature.name"]}</Text>
      </View>
      <View style={[styles.section, styles.sectionCenter]}>
        <Text style={[styles.signatureValue, styles.black]}>
          {receiptSettings && receiptSettings.doNotFillNameAndDate ? null : formattedDate}
        </Text>
        <Text style={styles.signatureText}>{messages["receipt.signature.date"]}</Text>
      </View>
      <View style={[styles.section, styles.sectionRight]} isSignField={true}>
        {receiptSignature && !isContractSign
        && !(fabricatorData.receiptSettings && fabricatorData.receiptSettings.hideSignatureField)
          ? <Image style={styles.signatureImage} src={receiptSignature} />
          : null}
        <Text style={styles.signatureText}>{messages["receipt.signature.signature"]}</Text>
      </View>
    </View>
  )
};

PrintDocumentSignature.propTypes = {
  styles: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  userInfo: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  isContractSign: PropTypes.bool,
  receiptSignature: PropTypes.string,
};

export default PrintDocumentSignature
